export default function() {
  return {
    measures: [],
    tyreCategories: []
  }
}
